import React from "react";
// @material-ui/core components
import ViewVeiculo from "components/View/ViewVeiculo.js";
import LoadingFull from "components/Loading/LoadingFull";
import api from 'services/api.js';
import {serverApi} from 'services/constante.js';
import {msg} from 'services/msg.js';
import MySnackbarErro from 'components/Uteis/MySnackbarErro.js';

import checaLiberacaoMenu from 'services/checaLiberacaoMenu';

  export default class VeiculoView extends React.Component {
  
    constructor(props) {
      super(props);

      checaLiberacaoMenu(props);

      this.state  = {
        veiculo: {Multas:[], Debitos: [], Dicas: []},
        loadingGrid: true,
        isErro: false
      };     
    } 
    componentDidMount(){
  
      let guid = this.props.match.params.guid;
      this.setState({isErro: false});

      api.get(serverApi.url + serverApi.versao + '/Veiculo/Guid/' + guid + '/Resumo').then(response => {
        this.setState({
          veiculo: response.data
        });
        
        console.log(response.data);
      })
      .catch(error => {
        console.error(error);
        this.setState({isErro: true}); 
       
      })
      .finally(() => {   
        this.setState({
          loadingGrid: false
        });   
      });      
    }
    
    render() {
    return (
      <>
        <LoadingFull display={this.state.loadingGrid} />        
          <ViewVeiculo veiculo={this.state.veiculo} />
        <MySnackbarErro IsErro={this.state.isErro} Mensagem={msg.semConexao} />
      </>
    );
  }
}
